import React from 'react';
import PropTypes from 'prop-types';
import './FormShare.scss';
import {
  BiMailSend, BiMessageSquareDots
} from "react-icons/bi";

const FormShare = () => {
  return (
    <div className="FormShare">
      <div className='row m-0 main_wizard_head d-none'>
        <div className='col-lg-4 p-2'>
          <p className='m-0'>Human right's and Environmental assessment</p>
        </div>
        <div className='col-lg-8'>
          <div className="wizard-content">
            <div className="tab-wizard wizard-circle wizard clearfix">
              <div className="steps clearfix">
                <ul role="tablist">
                  <li role="tab" aria-disabled="true" className="first done" >
                    <a href="javascript:void(0)" >
                      <span className="step">1</span> Summary
                    </a>
                  </li>
                  <li role="tab" aria-disabled="true" className="first current" >
                    <a href="javascript:void(0)">
                      <span className="step">2</span> Build
                    </a>
                  </li>
                  <li role="tab" aria-disabled="true" className="last disabled" >
                    <a href="javascript:void(0)" >
                      <span className="step">3</span> Preview
                    </a>
                  </li>
                  {/* <li role="tab" aria-disabled="true" className="last disabled" >
                    <a href="javascript:void(0)" >
                      <span className="step">4</span> Share
                    </a>
                  </li>
                  <li role="tab" aria-disabled="true" className="last disabled" >
                    <a href="javascript:void(0)" >
                      <span className="step">5</span> Analyze
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div >
      </div >
      <div className='row m-0 justify-content-center'>
        <div className='col-lg-6  text-center p-0'>
          <div className='ShareLink_box'>
            <h5>Share a Link</h5>
            <p>Copy and paste this URL to share your survey in an email, on a website, or on social media. this kind of collector is open by default and the link works until you close it. learn more</p>

            <div className='Copy_linkBox'>
              <a href='#'>Human%Right&Environmetal/view/a4f114f6-76db-428e-9a01-b8696ca6333e-f1a2/screen/38577318-a588-4274-9f5c-2f9fad5a5aac</a>
              <button className='btn btn-secondary'>Copy Link</button>
            </div>

          </div>
          <div className='Other_shareBox_section'>
            <h5>Other ways to share</h5>
            <div className='Other_shareBox'>
              <ul>
                <li>
                  <a href='#'>
                    <div className='Other_shareBox_singlebox'>
                      <BiMailSend />
                      Email
                    </div>
                  </a>
                </li>
                <li>
                  <a href='#'>
                    <div className='Other_shareBox_singlebox'>
                      <BiMessageSquareDots />
                      SMS
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default FormShare;
